const state = {
  filled: {},
  processing: false,
};

export default state;
